import { isDate } from 'date-fns';
import { StatisticsVariant } from '../types/statistic-variant';
import { ContentType } from '../types/content-type';
import { DateRange } from '../types/date-range';
import { ContentView } from '../types/content-view';

const variants: StatisticsVariant[] = ['MONTHLY', 'DAILY'];

export function isStatisticVariant(value: string): value is StatisticsVariant {
  return variants.includes(value as StatisticsVariant);
}

export function isDateRange(value: string): value is DateRange {
  if (!value) return false;
  const [from, to] = value.split(',');
  return isDate(new Date(from)) && isDate(new Date(to));
}

const contentTypes: ContentType[] = ['ROOM', 'DESK', 'GENERAL'];

export function isContentType(value: string): value is ContentType {
  return contentTypes.includes(value as ContentType);
}

const contentViews: ContentView[] = ['TABLE', 'CHART'];

export function isContentView(value: string): value is ContentView {
  return contentViews.includes(value as ContentView);
}
